import WindowSillsMeasurementValues from "./WindowSillsMeasurementValues";

export default WindowSillsMeasurementValues